import { render, staticRenderFns } from "./HumanResourceList.vue?vue&type=template&id=bc4e6268"
import script from "./HumanResourceList.vue?vue&type=script&lang=js"
export * from "./HumanResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports